import { put, takeLatest, all, call, fork } from "redux-saga/effects";
import { requestManagerActions } from "../../constants/actionTypes";
import {
  deploymentListSuccess,
  deploymentListError,
  errorTrackRequest,
  setRequestsList,
  successRequest,
  setRequestsListErr,
  errorRequest,
  successTrackRequest,
  updateReqSuccess,
  updateReqError,
  successDeploymentJobs,
  errorDeploymentJobs,
  setRequestLabList,
  errorRequestLabList,
  successRequestTicket,
  errorRequestTicket,
  successApproveDeclineRequest,
  errorApproveDeclineRequest,
  successDeleteRequestTicket,
  errorDeleteRequestTicket,
  successRetrieveResendNotification,
  errorRetrieveResendNotification,
  successNotifyAgain,
  errorNotifyAgain,
  exportRequestLoading,
  exportRequestSuccess,
  exportRequestError,
  bulkUpdateRequestLoading,
  bulkUpdateRequestSuccess,
  bulkUpdateRequestError,
} from "../actions/requestManager";
import {
  fetchRequestsList,
  fetchTrackRequest,
  setReqStatus,
  fetchDeploymentList,
  retrieveRequestApi,
  retrieveDeploymentJobsApi,
  retrieveRequestLabListApi,
  createRequestTicketApi,
  requestApproveDeclineTicketApi,
  deleteRequestLabTicketApi,
  retrieveResendNotificationApi,
  notifyAgainApi,
  exportRequestApi,
  bulkUpdateRequestApi,
} from "../api/requestManager";
import { statusCode } from "../../constants/apis/apiStatus";
import { toasterFlags } from "../../constants/componentConstants";
import { toastNotification } from "../../utils/toast";

export function* getRequestsListFn({ payload }) {
  try {
    const data = yield call(fetchRequestsList, payload);
    if (
      data?.status === statusCode.Ok200 ||
      data?.status === statusCode.Created201
    ) {
      yield put(setRequestsList(data));
    } else {
      yield put(setRequestsListErr(data));
    }
  } catch (err) {
    console.log(err);
    yield put(setRequestsListErr(err));
  }
}

export function* getDeploymentListFunction({ payload }) {
  try {
    const data = yield call(fetchDeploymentList, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(deploymentListSuccess(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.message);
      yield put(deploymentListError(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.message);
    yield put(deploymentListError(err));
  }
}

export function* getRequestFunction({ payload }) {
  try {
    const data = yield call(retrieveRequestApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successRequest(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.message);
      yield put(errorRequest(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.message);
    yield put(errorRequest(err));
  }
}

export function* getDeploymentJobsFunction({ payload }) {
  try {
    const data = yield call(retrieveDeploymentJobsApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successDeploymentJobs(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.message);
      yield put(errorDeploymentJobs(data));
    }
  } catch (err) {
    toastNotification(toasterFlags.WARN, err?.message);
    yield put(errorDeploymentJobs(err));
  }
}

export function* getTrackRequestFunction({ payload }) {
  try {
    const data = yield call(fetchTrackRequest, payload);
    if (
      data?.status === statusCode.Ok200 ||
      data?.status === statusCode.Created201
    ) {
      yield put(successTrackRequest(data));
    } else {
      yield put(errorTrackRequest(data));
      toastNotification(toasterFlags.ERROR, data?.message);
    }
  } catch (err) {
    yield put(errorTrackRequest(err));
    toastNotification(toasterFlags.ERROR, err?.message);
  }
}

export function* retrieveResendNotificationFunction({ payload }) {
  try {
    const data = yield call(retrieveResendNotificationApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successRetrieveResendNotification(data));
    } else {
      yield put(errorRetrieveResendNotification(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(errorRetrieveResendNotification(err));
  }
}

export function* notifyAgainFunction({ payload }) {
  try {
    const data = yield call(notifyAgainApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(successNotifyAgain(data));
      toastNotification(toasterFlags.SUCCESS, data?.data?.Success);
    } else {
      yield put(errorNotifyAgain(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
    }
  } catch (err) {
    yield put(errorNotifyAgain(err));
  }
}

export function* updateReqStatusFn({ payload }) {
  try {
    const data = yield call(setReqStatus, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(updateReqSuccess(data));
      toastNotification(toasterFlags.SUCCESS, data?.data?.Success);
    } else {
      yield put(updateReqError(data?.response?.data || data));
      toastNotification(
        toasterFlags.ERROR,
        data?.response?.data || data?.data?.error
      );
    }
  } catch (err) {
    yield put(updateReqError(err?.message));
    toastNotification(toasterFlags.ERROR, err?.message);
  }
}

export function* getRequestLabListFunction({ payload }) {
  try {
    const data = yield call(retrieveRequestLabListApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(setRequestLabList(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorRequestLabList(data));
    }
  } catch (err) {
    yield put(errorRequestLabList(err));
  }
}

export function* createRequestTicketFunction({ payload }) {
  try {
    const data = yield call(createRequestTicketApi, payload);
    if (data?.status === statusCode.Created201) {
      yield put(successRequestTicket(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorRequestTicket(data));
    }
  } catch (err) {
    yield put(errorRequestTicket(err));
  }
}

export function* requestApproveDeclineTicketFunction({ payload, id }) {
  try {
    const data = yield call(requestApproveDeclineTicketApi, id, payload);
    if (data?.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, data?.data?.Success);
      yield put(successApproveDeclineRequest(data));
    } else {
      toastNotification(
        toasterFlags.WARN,
        data?.data?.message?.ticket_status[0]
      );
      yield put(errorApproveDeclineRequest(data));
    }
  } catch (err) {
    yield put(errorApproveDeclineRequest(err));
  }
}

export function* deleteRequestLabTicketFunction({ payload }) {
  try {
    const data = yield call(deleteRequestLabTicketApi, payload);
    if (data?.status === statusCode.Ok200) {
      toastNotification(toasterFlags.SUCCESS, data?.data?.Success);
      yield put(successDeleteRequestTicket(data));
    } else {
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(errorDeleteRequestTicket(data));
    }
  } catch (err) {
    yield put(errorDeleteRequestTicket(err));
  }
}

export function* exportRequestSaga({ payload }) {
  try {
    yield put(exportRequestLoading(true));
    const data = yield call(exportRequestApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(exportRequestSuccess(data));
      toastNotification(toasterFlags.WARN, data?.data?.message);
      yield put(exportRequestLoading(false));
    } else {
      yield put(exportRequestError(data));
      toastNotification(toasterFlags.ERROR, data?.data?.message);
      yield put(exportRequestLoading(false));
    }
  } catch (err) {
    console.log(err);
    yield put(exportRequestError(err));
  }
}

export function* bulkUpdateRequestSaga({ payload }) {
  try {
    yield put(bulkUpdateRequestLoading(true));
    const data = yield call(bulkUpdateRequestApi, payload);
    if (data?.status === statusCode.Ok200) {
      yield put(bulkUpdateRequestSuccess(data));
      toastNotification(toasterFlags.SUCCESS, data?.data?.Success);
      yield put(bulkUpdateRequestLoading(false));
    } else {
      yield put(bulkUpdateRequestError(data));
      toastNotification(toasterFlags.ERROR, data?.data?.error);
      yield put(bulkUpdateRequestLoading(false));
    }
  } catch (err) {
    console.log(err);
    yield put(bulkUpdateRequestError(err));
  }
}

export function* requestManagerRootSaga() {
  yield takeLatest(
    requestManagerActions.REQUESTS_LIST_REQUEST,
    getRequestsListFn
  );
  yield takeLatest(
    requestManagerActions.DEPLOYMENT_LIST_REQUEST,
    getDeploymentListFunction
  );
  yield takeLatest(requestManagerActions.RETRIEVE_REQUEST, getRequestFunction);
  yield takeLatest(
    requestManagerActions.APPROVE_DECLINE_REQUEST,
    updateReqStatusFn
  );
  yield takeLatest(
    requestManagerActions.REQUEST_TRACK_REQUEST,
    getTrackRequestFunction
  );
  yield takeLatest(
    requestManagerActions.RETRIEVE_DEPLOYMENT_JOBS,
    getDeploymentJobsFunction
  );
  yield takeLatest(
    requestManagerActions.GET_REQUEST_LAB,
    getRequestLabListFunction
  );
  yield takeLatest(
    requestManagerActions.SET_REQUEST_TICKET,
    createRequestTicketFunction
  );
  yield takeLatest(
    requestManagerActions.SET_APPROVE_DECLINE_REQUEST,
    requestApproveDeclineTicketFunction
  );
  yield takeLatest(
    requestManagerActions.REQUEST_DELETE_REQUEST_TICKET,
    deleteRequestLabTicketFunction
  );
  yield takeLatest(
    requestManagerActions.RESEND_NOTIFICATION_RETRIEVE_REQUEST,
    retrieveResendNotificationFunction
  );
  yield takeLatest(
    requestManagerActions.REQUEST_NOTIFY_AGAIN,
    notifyAgainFunction
  );
  yield takeLatest(
    requestManagerActions.EXPORT_REQUEST_ACTION,
    exportRequestSaga
  );
  yield takeLatest(
    requestManagerActions.BULK_UPDATE_REQUEST_ACTION,
    bulkUpdateRequestSaga
  );
}

export default function* rootSaga() {
  yield all([fork(requestManagerRootSaga)]);
}
